import {
  GAME_SCROLL_SAVE_SUCCESS,
  GAME_SCROLL_CLEAR,
  GAME_TABS_SUCCESS,
  GAME_ERROR,
  GAME_CLASS_APPS_SUCCESS,
  GAME_CLASS_LIST_SUCCESS,
  GAME_RANKS_TAB_SUCCESS,
  GAME_RANKS_MORE_LIST_SUCCESS,
  SET_GAME_CATEGORY_TAG,
  SET_SELECTED_TAG,
  DELETE_SELECTED_TAG,
  SET_GAME_CATEGORY_LIST,
  SET_GAME_CODE,
  SET_SHOW_CATEGORY_TAG,
  SET_SEARCH_TAG,
  CLEAR_TAG,
  SET_SELECTED_A_TAG,
  SET_APP_SORT,
  SET_TAG_APP_LIST,
  SET_LIST_LOADING,
  GAME_EXT_SCREEN_SUCCESS,
} from '../constants/game';

const initState = {
  at: 0,
  menu: [], // 游戏页面的二级菜单
  error: false,
  appList: {
    loading: false,
  }, // 游戏分类页面保存的app列表及其相关信息
  classList: [],
  rankTabList: [], // 榜单页面list
  rankMoreList: {
    loading: false,
    refresh: false,
    list: [],
    desc: '',
  },
  categoryTag: [],
  categorySelectedTag: [],
  categoryShow: true,
  gameSelectCode: '',
  gameExtScreen: null,
  showCategoryList: [],
  gameSearchTag: [],
  gameSort: 1,
  gameAppList: {
    list3: [],
    list4: [],
    list5: [],
    list6: [],
  },
  gameListLoading: false,
};

const game = (state = initState, payload = {}) => {
  switch (payload.type) {
    case GAME_SCROLL_SAVE_SUCCESS:
      return { ...state, at: payload.at };
    case GAME_SCROLL_CLEAR:
      return { ...state, at: 0 };
    case GAME_TABS_SUCCESS:
      return { ...state, menu: payload.menu.sort((a, b) => a.order - b.order) };
    case GAME_ERROR:
      return { ...state, error: payload.error };
    case GAME_CLASS_APPS_SUCCESS:
      return {
        ...state,
        appList: payload.appList.refresh
          ? payload.appList
          : {
              ...payload.appList,
              apps: [...(state.appList.apps || []), ...(payload.appList.apps || [])],
            },
      };
    case GAME_CLASS_LIST_SUCCESS:
      return {
        ...state,
        classList: payload.classList.filter(
          cls => cls.childClassList && cls.childClassList.length > 0,
        ),
      };

    case GAME_RANKS_TAB_SUCCESS:
      return {
        ...state,
        rankTabList: payload.rankTabList,
      };
    case GAME_RANKS_MORE_LIST_SUCCESS:
      return {
        ...state,
        rankMoreList: payload.rankMoreList.refresh
          ? payload.rankMoreList
          : {
              ...payload.rankMoreList,
              list: [...(state.rankMoreList.list || []), ...(payload.rankMoreList.list || [])],
            },
      };
    case SET_GAME_CATEGORY_TAG:
      return {
        ...state,
        categoryTag: payload.list,
        gameSelectCode: payload.code,
      };
    case SET_SELECTED_TAG:
      let showList = state.showCategoryList.map(item => {
        return {
          ...item,
          tags: item.tags.map(i => {
            if (i.tagId === payload.payload.info.tagId) {
              if (i.tagSelect === 1) {
                return { ...i, tagSelect: 0 };
              } else {
                return { ...i, tagSelect: 1 };
              }
            } else {
              return i;
            }
          }),
        };
      });

      let selectIndex = state.categorySelectedTag.findIndex(
        i => i.tagId === payload.payload.info.tagId,
      );
      let selectArr = [...state.categorySelectedTag];
      if (selectIndex > -1) {
        selectArr.splice(selectIndex, 1);
      } else {
        selectArr.push(payload.payload.info);
      }
      return {
        ...state,
        categorySelectedTag: selectArr,
        showCategoryList: showList,
      };
    case DELETE_SELECTED_TAG:
      return {
        ...state,
      };
    case SET_GAME_CATEGORY_LIST:
      return {
        ...state,
        categoryShow: payload.payload,
      };
    case SET_GAME_CODE:
      return {
        ...state,
        gameSelectCode: payload.payload,
      };
    case GAME_EXT_SCREEN_SUCCESS:
      return {
        ...state,
        gameExtScreen: payload.gameExtScreen,
      };
    case SET_SHOW_CATEGORY_TAG:
      let showCategoryList = [];
      let showCategoryListIndex = state.categoryTag.findIndex(i => i.code === payload.payload);
      if (payload.payload === '1' && showCategoryListIndex > -1) {
        showCategoryList = state.categoryTag[showCategoryListIndex].pcGameTagList;
      } else {
        showCategoryList = state.categoryTag[showCategoryListIndex];
      }
      return {
        ...state,
        showCategoryList: showCategoryList,
      };
    case SET_SEARCH_TAG:
      return {
        ...state,
        gameSearchTag: payload.data,
      };
    case CLEAR_TAG:
      return {
        ...state,
        categorySelectedTag: [],
      };
    case SET_SELECTED_A_TAG:
      let Aobj = {
        ...state.showCategoryList,
        childClassList: state.showCategoryList?.childClassList.map(i => {
          if (i.childCode === payload.payload.info.childCode) {
            if (i.tagSelect === 1) {
              return { ...i, tagSelect: 0 };
            } else {
              return { ...i, tagSelect: 1 };
            }
          } else {
            return i;
          }
        }),
      };
      let selectA = [...state.categorySelectedTag];

      let selectAIndex = selectA.findIndex(
        i =>
          i.childCode === payload.payload.info.childCode &&
          i.childName === payload.payload.info.childName,
      );

      if (selectAIndex > -1) {
        selectA = selectA.filter(i => i.childCode !== payload.payload.info.childCode);
      } else {
        selectA.push(payload.payload.info);
      }
      return {
        ...state,
        categorySelectedTag: selectA,
        showCategoryList: Aobj,
      };
    case SET_APP_SORT:
      return {
        ...state,
        gameSort: payload.payload,
      };
    case SET_TAG_APP_LIST:
      let list = payload.data?.apps ?? [];
      let list3 = payload.refresh ? [] : state.gameAppList.list3;
      let list4 = payload.refresh ? [] : state.gameAppList.list4;
      let list5 = payload.refresh ? [] : state.gameAppList.list5;
      let list6 = payload.refresh ? [] : state.gameAppList.list6;

      if (list3?.[list3.length - 1]?.length < 3) {
        let Length = 3 - list3?.[list3.length - 1]?.length;
        let sliceA = list.slice(0, Length);
        list3[list3.length - 1].push(...sliceA);
      } else {
        for (let i = 0; i < list.length; i++) {
          list3.push(list?.slice(i, i + 3));
          i = i + 2;
        }
      }
      if (list4?.[list4.length - 1]?.length < 4) {
        let Length = 4 - list4?.[list4.length - 1]?.length;
        let sliceA = list.slice(0, Length);
        list4[list4.length - 1].push(...sliceA);
      } else {
        for (let i = 0; i < list.length; i++) {
          list4.push(list?.slice(i, i + 4));
          i = i + 3;
        }
      }
      if (list5?.[list5.length - 1]?.length < 5) {
        let Length = 5 - list5?.[list5.length - 1]?.length;
        let sliceA = list.slice(0, Length);
        list5[list5.length - 1].push(...sliceA);
      } else {
        for (let i = 0; i < list.length; i++) {
          list5.push(list?.slice(i, i + 5));
          i = i + 4;
        }
      }
      if (list6?.[list6.length - 1]?.length < 6) {
        let Length = 6 - list6?.[list6.length - 1]?.length;
        let sliceA = list.slice(0, Length);
        list6[list6.length - 1].push(...sliceA);
      } else {
        for (let i = 0; i < list.length; i++) {
          list6.push(list?.slice(i, i + 6));
          i = i + 5;
        }
      }

      if (payload.data.hasNextPage === 0) {
        // list3.push([]);
        // list4.push([]);
        // list5.push([]);
        // list6.push([]);
      }

      return {
        ...state,
        gameAppList: {
          hasNextPage: payload.data.hasNextPage,
          list3: payload.refresh && !payload.data ? [] : list3,
          list4: payload.refresh && !payload.data ? [] : list4,
          list5: payload.refresh && !payload.data ? [] : list5,
          list6: payload.refresh && !payload.data ? [] : list6,
          apps: payload.refresh
            ? payload.data.apps
            : [...state.gameAppList?.apps, ...payload.data.apps],
        },
      };
    case SET_LIST_LOADING:
      return {
        ...state,
        gameListLoading: payload.payload,
        gameAppList: payload.payload
          ? {
              list3: [],
              list4: [],
              list5: [],
              list6: [],
            }
          : { ...state.gameAppList },
      };
    default:
      return state;
  }
};

export default game;
